<template>
  <v-layout row wrap class="px-2 nav-toolbar">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="miniToolbar"
      :mini-variant-width="56"
      color="white blueMenu--text"
      app
      short
      class="elevation-3"
      ref="toolbar"
      width="240"
    >
      <v-toolbar
        prominent
        color="white text-center right-toolbar"
        max-height="56px"
        :class="{ 'pl-2': !miniToolbar, 'pl-1': miniToolbar }"
      >
        <img
          v-if="miniToolbar"
          src="@/assets/logo/Logo_small.png"
          width="25"
          alt="Logo NAV"
          class="mx-auto mt-2"
        />
        <img
          v-else
          src="@/assets/logo/Logo.png"
          width="153"
          alt="Logo Mofin"
          class="mx-auto mt-2"
        />
      </v-toolbar>
      <VuePerfectScrollbar
        class="drawer-menu--scroll__"
        :settings="scrollSettings"
      >
        <v-list id="mainMenu" dense>
          <template v-for="item in items">
            <v-list-item
              :id="item.id"
              :key="item.title"
              :to="item.component"
              v-if="item.items.length === 0 && checkPermission(item)"
              active-class="menuActive white--text custom-list-active"
              exact-active-class="menuActive white--text custom-list-active"
            >
              <v-list-item-action>
                <div v-if="item.icon === 'svg-menu-8'">
                  <icon-menu-8 />
                </div>
                <div v-else-if="item.icon === 'svg-menu-5'">
                  <icon-menu-5 />
                </div>
                <v-icon v-else-if="item.icon.startsWith('mdi')">
                  {{ item.icon }}
                </v-icon>
                <v-icon v-else-if="item.icon.startsWith('ri')">
                  {{ item.icon }}
                </v-icon>
                <v-icon v-else-if="item.icon.startsWith('icon')">
                  <div>{{ item.icon }}</div>
                </v-icon>
                <img v-else class="icon-color" :src="getIcon(item.icon)" />
              </v-list-item-action>
              <v-list-item-content :title="item.title">
                <v-list-item-title> {{ item.title }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              v-if="item.items.length >= 1 && checkParentPermissions(item)"
              :key="item.title"
              :id="item.id"
              v-model="item.active"
              :title="item.title"
              append-icon="mdi-chevron-right"
            >
              <template v-slot:activator v-if="item.items">
                <v-list-item-action>
                  <div v-if="item.icon === 'svg-menu-8'">
                    <icon-menu-8 />
                  </div>
                  <div v-else-if="item.icon === 'svg-menu-5'">
                    <icon-menu-5 />
                  </div>
                  <v-icon v-else-if="item.icon.startsWith('mdi')">
                    {{ item.icon }}
                  </v-icon>
                  <v-icon v-else-if="item.icon.startsWith('ri')">
                    {{ item.icon }}
                  </v-icon>
                  <v-icon v-else-if="item.icon.startsWith('icon')">
                    {{ item.icon }}
                  </v-icon>
                  <img v-else class="icon-color" :src="getIcon(item.icon)" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="subItem in item.items">
                <template v-if="subItem.isSub">
                  <v-list-group
                    :key="subItem.title"
                    sub-group
                    no-action
                    active-class="menuActive white--text custom-list-active"
                    exact-active-class="menuActive white--text custom-list-active"
                    v-if="checkPermission(subItem)"
                    prepend-icon="mdi-chevron-right"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ subItem.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item
                      :to="subChild.to"
                      link
                      v-for="(subChild, index) in subItem.children"
                      :key="index"
                      active-class="menuActive white--text custom-list-active"
                      exact-active-class="menuActive white--text custom-list-active"
                    >
                      <v-list-item-title>
                        {{ subChild.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-item
                    v-if="checkPermission(subItem)"
                    :id="subItem.id"
                    :key="subItem.title"
                    active-class="menuActive white--text custom-list-active"
                    exact-active-class="menuActive white--text custom-list-active"
                    :to="
                      subItem.query
                        ? { name: subItem.href, params: { id: subItem.query } }
                        : { name: subItem.href }
                    "
                    @click="title = item.title"
                    exact
                  >
                    <v-list-item-action class="text-center">
                      <v-icon class="ml-1" size="10px !important"
                        >ri-radio-button-fill</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-text="subItem.title">
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </template>
            </v-list-group>
          </template>
        </v-list>
      </VuePerfectScrollbar>
    </v-navigation-drawer>
    <v-flex>
      <v-app-bar app short color="white" class="pr-7">
        <v-app-bar-nav-icon
          style="margin-left: 8px !important"
          @click.stop="handleDrawer()"
        >
        </v-app-bar-nav-icon>
        <v-flex xs4 class="pa-0">
          <v-toolbar-title class="pl-5">
            <v-layout row column>
              <span
                class="primary--text mt-7 mb-0 pb-0 text-capitalize  title-page"
              >
                {{ $route.meta.title }}
              </span>
              <v-breadcrumbs
                class="px-0 mt-0 mb-0 pt-0"
                divider="|"
                :items="breadcrumbs"
              >
                <template v-slot:item="{ item }">
                  <v-breadcrumbs-item
                    :href="item.href"
                    :disabled="item.disabled"
                    class="text-subtitle-small pt-0 mt-0 text-capitalize "
                  >
                    {{ item.text }}
                  </v-breadcrumbs-item>
                </template>
              </v-breadcrumbs>
            </v-layout>
          </v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4 class="pl-4 mr-4">
          <search-toolbar @isLoading="load" />
        </v-flex>
        <v-menu
          class="mx-2"
          offset-y
          min-width="100"
          nudge-left="100"
          nudge-top="-3"
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" class="text-capitalize fs-13" dark v-on="on">
              <img class="mr-2" src="@/assets/images/icon/help-circle.svg" />
              Help Center
            </v-btn>
          </template>
          <v-list class="primary pa-0">
            <v-list-item disabled class="py-1">
              <v-list-item-title>
                <h3 class="white--text fs-12 font-weight-medium">
                  HELP & RESOURCES
                </h3>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="white">
              <v-list-item-action class="ma-0">
                <img src="@/assets/images/icon/ceklis.png" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-medium">
                  Help Center
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          class="mx-2"
          offset-y
          min-width="100"
          nudge-left="100"
          nudge-top="-3"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon color="grey darken-3" v-on="on">
              <img src="@/assets/images/icon/settings.png" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="showChangePassword">
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn icon color="grey darken-1" @click="readNotif()">
          <v-badge color="menuActive" overlap>
            <span slot="badge" color="grey darken-1">
              {{ notification.count ? notification.count : 0 }}
            </span>
            <v-icon medium>notifications_none</v-icon>
          </v-badge>
        </v-btn>
        <!-- <v-btn icon color="grey darken-1" @click="confirmLogout()">
          <v-icon medium>mdi-logout</v-icon>
        </v-btn> -->
        <v-menu
          class="mx-2"
          offset-y
          min-width="100"
          nudge-left="50"
          nudge-top="-3"
        >
          <template v-slot:activator="{ on }">
            <v-btn elevation="4" class="ml-3" small icon v-on="on">
              <v-avatar size="30px">
                <v-icon color="">ri-user-6-line</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-item color="primary">
              <v-list-item-title class="text-capitalize my-3">
                <h3
                  class="body-2 text-capitalize"
                  style="line-height: 1rem !important"
                >
                  <div v-if="user != 'null'">{{ user }}</div>
                  <div v-else>{{ email }}</div>
                </h3>
                <h3
                  class="body-2 grey--text text--lighten-1 text-capitalize"
                  style="line-height: 1rem !important"
                >
                  {{ desc.desc ? desc.desc : desc.text }}
                </h3>
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item dense class="pa-0 ma-0" @click="showDialog = true">
              <v-list-item-avatar>
                <v-icon>ri-swap-box-line</v-icon>
              </v-list-item-avatar>
              <v-list-item-title> Switch Profile</v-list-item-title>
            </v-list-item>
            <v-list-item dense class="pa-0 ma-0" @click="confirmLogout()">
              <v-list-item-avatar>
                <v-icon>ri-logout-circle-line</v-icon>
              </v-list-item-avatar>
              <v-list-item-title> Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-content>
        <!-- Page Header -->
        <div
          class="page-wrapper"
          style="min-height: 85vh;padding-left; 28px !important"
        >
          <router-view></router-view>
        </div>
      </v-content>
    </v-flex>
    <v-navigation-drawer
      v-model="notifDrawer"
      temporary
      right
      app
      short
      width="369"
      class="rounded-top-left-10 rounded-bottom-left-10"
    >
      <v-list-item class="primary px-2">
        <v-list-item-content class="py-2">
          <v-col class="pa-0">
            <v-btn dark icon @click="notifDrawer = !notifDrawer">
              <v-icon style="font-size: 24px !important">close</v-icon>
            </v-btn>
            <span
              class="
                white--text
                fs-14
                lh-24
                font-weight-bold
                vertical-align-middle
              "
            >
              NOTIFICATION
            </span>
          </v-col>
          <v-col class="text-right py-0 pr-2" cols="3">
            <v-chip
              color="softRed"
              x-small
              class="fs-12 lh-15 white--text font-weight-bold"
              style="height: 19px; width: 62px; border-radius: 24px"
            >
              {{ notification.count || 0 }} New
            </v-chip>
          </v-col>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="px-4">
        <v-list-item-content>
          <v-text-field
            outlined
            single-line
            rounded
            hide-details
            placeholder="Search"
            prepend-inner-icon="search"
            class="py-0 dashSearch"
          ></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <VuePerfectScrollbar
        class="drawer-notif--scroll__"
        :settings="scrollNotifSettings"
      >
        <v-list dense class="pt-0" v-if="notification.notification">
          <v-list-item v-if="notification.notification.length === 0">
            <v-list-item-title class="text-center">
              No notification found.
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-else
            v-for="(item, index) in notification.notification"
            :key="'notif' + index"
            class="border-b-1"
            :disabled="item.read && item.type_field !== 'APPROVAL'"
            :style="item.read ? 'background: #F8F8F8;' : ''"
            @click="redirectApproval(item)"
          >
            <v-list-item-icon>
              <img
                v-if="
                  item.type_field === 'APPROVAL' ||
                    item.type_field === 'APPROVED'
                "
                src="@/assets/images/icon/icon-approval.png"
                height="40"
                width="auto"
              />
              <v-icon
                color="lime"
                v-else-if="item.type_field === 'CONFIG'"
                class="pa-0 pt-4"
                style="font-size: 48px !important; margin-left: -5px"
                >info</v-icon
              >
              <img
                v-else
                src="@/assets/images/icon/icon-reject.png"
                height="40"
                width="auto"
              />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="f-14 lh-17 font-weight-normal mb-1">
                <span :class="item.read ? '' : 'menuActive--text'">
                  You have new update
                </span>
              </v-list-item-title>
              <span class="fs-12 font-weight-normal bluegrey--text">
                {{ item.message }}
              </span>
              <p class="fs-10 my-1 font-weight-normal bluegrey--text">
                {{ formatDateTime(item.created_at) }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </VuePerfectScrollbar>
    </v-navigation-drawer>
    <v-dialog v-model="showDialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Switch Profile</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <ValidationProvider
                  name="Profile"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    id="select-profile"
                    required
                    xs12
                    v-model="profileId"
                    :items="computedItems"
                    return-object
                    item-text="text"
                    label="Select Profile"
                    dense
                    :error-messages="errors"
                  >
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="showDialog = false">
            Close
          </v-btn>
          <v-btn color="primary" dark @click="submit()"> Submit </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalChangePassword" persistent max-width="400px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Change Password</span>
        </v-card-title>
        <v-card-text class="pa-5">
          <ValidationObserver ref="changePassword">
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <ValidationProvider
                    name="Current Password"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                      :type="show ? 'text' : 'password'"
                      name="Current Password"
                      placeholder="Current Password"
                      id="current-password"
                      v-model="current_password"
                      class="pa-0"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <ValidationProvider
                    name="New Password"
                    :rules="{ required: true, min: 8 }"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      :type="show1 ? 'text' : 'password'"
                      name="New Password"
                      placeholder="New Password"
                      id="new-password"
                      v-model="new_password"
                      class="pa-0"
                      :error-messages="errors"
                      hint="At least 8 characters"
                      counter
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <ValidationProvider
                    name="Confirm Password"
                    :rules="{ required: true, min: 8 }"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                      :type="show2 ? 'text' : 'password'"
                      name="Confirm Password"
                      placeholder="Confirm Password"
                      id="confirm-password"
                      v-model="confirm_password"
                      class="pa-0"
                      :error-messages="errors"
                      hint="At least 8 characters"
                      counter
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions class="pb-3 px-6">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="modalChangePassword = false">
            Close
          </v-btn>
          <v-btn color="primary" dark @click="changePassword()"> Submit </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </v-layout>
</template>

<script>
import ProgressDialog from '../components/progress_dialog';
import SearchToolbar from '../components/SearchToolbar';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import iconMenu5 from './baseIcons/icons/iconMenu5.vue';
import iconMenu8 from './baseIcons/icons/iconMenu8.vue';
import ACLMixin from '../mixins/ACLMixin';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import Swal from 'sweetalert2';
import { mapState } from 'vuex';

export default {
  mixins: [ACLMixin, LoginAsMixin],
  props: {
    source: String
  },
  components: {
    'progress-dialog': ProgressDialog,
    VuePerfectScrollbar,
    iconMenu8,
    iconMenu5,
    'search-toolbar': SearchToolbar
  },
  data: () => ({
    notifScrollSettings: {
      maxScrollbarLength: 260
    },
    scrollNotifSettings: {
      maxScrollbarLength: 500
    },
    dialog: false,
    progressDialogLoading: false,
    showDialog: false,
    show: false,
    show1: false,
    show2: false,
    modalChangePassword: false,
    new_password: '',
    current_password: '',
    confirm_password: '',
    disabledItems: '',
    title: 'Dashboard',
    user: localStorage.getItem('name'),
    email: localStorage.getItem('username'),
    desc: JSON.parse(localStorage.getItem('userProfile')),
    profileItems: JSON.parse(localStorage.getItem('profileList')),
    drawer: true,
    profileId: null,
    timeout: null,
    breadcrumbs: [
      {
        text: 'DASHBOARD',
        disabled: true,
        href: 'breadcrumbs_dashboard'
      },
      {
        text: 'A&P OVERVIEW',
        disabled: true,
        href: 'breadcrumbs_link_1'
      }
    ],
    scrollSettings: {
      maxScrollbarLength: 160
    },
    items: [
      // {
      //   id: 'dashboard',
      //   icon: 'bar-chart-2',
      //   title: 'Dashboard',
      //   component: '/',
      //   items: [],
      //   acl: [
      //     {
      //       name: 'dashboard',
      //       permission: 'view',
      //     },
      //   ],
      // },
      {
        icon: 'ri-pie-chart-line',
        title: 'Dashboard',
        items: [
          {
            id: 'dasboard-report',
            title: 'A&P Overview',
            href: 'dashboard',
            acl: [
              {
                name: 'dashboard',
                permission: 'view'
              }
            ]
          },
          {
            id: 'topline',
            title: 'Topline Report',
            href: 'topline',
            acl: [
              {
                name: 'topline_report',
                permission: 'view'
              }
            ]
          },
          {
            id: 'power_bi',
            title: 'A&P Power BI',
            href: 'power_bi',
            acl: [
              {
                name: 'power_bi',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-calendar-todo-line',
        title: 'Monthly Report',
        items: [
          {
            id: 'monthly-topline-report',
            title: 'Summary Report',
            href: 'monthly-topline-report',
            query: 'all',
            acl: [
              {
                name: 'view_monthly_topline_report',
                permission: 'view'
              }
            ]
          },
          {
            id: 'consolidated-report-io',
            title: 'Consolidated Report IO',
            href: 'consolidated-report-io',
            query: 'all',
            acl: [
              {
                name: 'view_monthly_consolidate_report',
                permission: 'view'
              }
            ]
          },
          {
            id: 'consolidated-report-po',
            title: 'Consolidated Report PO',
            href: 'consolidated-report-po',
            query: 'all',
            acl: [
              {
                name: 'view_monthly_consolidate_report',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-window-2-fill',
        title: 'Budgeting',
        items: [
          {
            id: 'budget-report',
            title: 'Budget Report',
            href: 'budgeting-report',
            acl: [
              {
                name: 'view_budget_report_a',
                permission: 'view'
              }
            ]
          },
          {
            id: 'budget-history',
            title: 'History',
            href: 'budgetHistory',
            acl: [
              {
                name: 'budgetMonitoring',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-refund-2-fill',
        title: 'Spending',
        items: [
          {
            id: 'spending-report',
            title: 'Spending Report',
            href: 'spending',
            acl: [
              {
                name: 'view_spending_report',
                permission: 'view'
              }
            ]
          },
          {
            id: 'spending-approval',
            title: 'Spending Approval & Verification',
            href: 'approval-dynamic',
            acl: [
              {
                name: 'approve_spending',
                permission: 'approve'
              }
            ]
          },
          {
            id: 'backup-spending',
            title: 'Backup Spending',
            href: 'backup-spending',
            acl: [
              {
                name: 'view_backup_spending',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-file-damage-line',
        title: 'PO & Non PO Monitoring',
        items: [
          {
            id: 'monitoring',
            title: 'PO Report',
            href: 'po-report',
            acl: [
              {
                name: 'po_monitoring',
                permission: 'view'
              }
            ]
          },
          {
            id: 'monitoring',
            title: 'Non-PO Report',
            href: 'non-po',
            acl: [
              {
                name: 'po_monitoring',
                permission: 'view'
              }
            ]
          },
          {
            id: 'monitoring',
            title: 'History Log Upload',
            href: 'history-log-upload',
            acl: [
              {
                name: 'history_log',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-settings-line',
        title: 'Integration',
        items: [
          {
            id: 'upload-bi',
            title: 'Upload BI Document',
            href: 'upload-bi',
            acl: [
              {
                name: 'po_upload',
                permission: 'create'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-apps-2-line',
        title: 'SSHCF',
        items: [
          {
            title: 'Dashboard',
            href: 'sshcf_dashboard',
            acl: [
              {
                name: 'dashboard_sshcf',
                permission: 'view'
              }
            ]
          },
          {
            title: 'Request',
            href: 'sshcf_requests',
            acl: [
              {
                name: 'request_sshcf',
                permission: 'create'
              }
            ]
          },
          {
            title: 'SLA Reports',
            href: 'sshcf_sla',
            acl: [
              {
                name: 'sla_reports_sshcf',
                permission: 'create'
              }
            ]
          },
          {
            title: 'Sponsorship Reports',
            href: 'sshcf_sponsorship_reports',
            acl: [
              {
                name: 'sponsorship_reports_sshcf',
                permission: 'create'
              }
            ]
          }
        ],
        acl: [
          // {
          //   name: 'key_highlight',
          //   permission: 'view'
          // }
        ]
      },
      {
        icon: 'mdi-layers',
        title: 'SSHCP',
        items: [
          {
            title: 'Dashboard',
            href: 'sshcp_dashboard',
            acl: [
              {
                name: 'dashboard_sshcp',
                permission: 'view'
              }
            ]
          },
          {
            title: 'Master Data',
            href: 'sshcp',
            isSub: true,
            acl: [
              {
                name: 'view_sshcp_master_data',
                permission: 'view'
              }
            ],
            children: [
              {
                title: 'Region',
                to: '/sshcp/regions'
              },
              {
                title: 'District',
                to: '/sshcp/districts'
              },
              {
                title: 'Group',
                to: '/sshcp/groups'
              },
              {
                title: 'Vendor',
                to: '/sshcp/vendors'
              },
              {
                title: 'Activities',
                to: '/sshcp/activities'
              }
            ]
          },
          {
            title: 'Approval Management',
            href: 'sshcp',
            isSub: true,
            acl: [
              {
                name: 'view_approval_management_sshcp',
                permission: 'view'
              }
            ],
            children: [
              {
                title: 'User Mapping',
                to: '/sshcp/approval/user'
              },
              {
                title: 'Approval Mapping',
                to: '/sshcp/approval/mapping'
              }
            ]
          },
          {
            title: 'My Pending Approval',
            href: 'pending_approval',
            acl: [
              {
                name: 'view_form_request_sshcp',
                permission: 'view'
              }
            ]
          },
          {
            title: 'Form Request',
            href: 'sshcp_request',
            acl: [
              {
                name: 'view_form_request_sshcp',
                permission: 'view'
              }
            ]
          },
          {
            title: 'SLA Report',
            href: 'sshcp_sla_report',
            acl: [
              {
                name: 'view_sla_sshcp',
                permission: 'view'
              }
            ]
          },
          {
            title: 'Budget Mapping (PO)',
            href: 'sshcp_budget_mapping',
            acl: [
              {
                name: 'view_budget_mapping_sshcp',
                permission: 'view'
              }
            ]
          },
          {
            title: 'Re-Route Request',
            href: 'sshcp_reroute',
            acl: [
              {
                name: 'view_sshcp_master_data',
                permission: 'view'
              }
            ]
          },
          {
            title: 'History Request',
            href: 'sshcp_history',
            acl: [
              {
                name: 'view_form_request_sshcp',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-list-settings-line',
        title: 'Master Data',
        items: [
          {
            id: 'channel',
            title: 'Channel',
            href: 'channel',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'position',
            title: 'Position',
            href: 'position',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'entity',
            title: 'Entity',
            href: 'entity',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'house',
            title: 'House',
            href: 'house',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'brand',
            title: 'Brand',
            href: 'brand',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'division',
            title: 'Division',
            href: 'division',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'department',
            title: 'Department',
            href: 'department',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'stage',
            title: 'Stage',
            href: 'stage',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'productHierarchy',
            title: 'Product Hierarchy',
            href: 'productHierarchy',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'costCenter',
            title: 'Cost Center',
            href: 'costCenter',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'costCategory',
            title: 'Cost Category',
            href: 'costCategory',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'costElement',
            title: 'Cost Element',
            href: 'costElement',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'costConsumer',
            title: 'Cost Consumer',
            href: 'costConsumer',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'taxonomy',
            title: 'Taxonomy',
            href: 'taxonomy',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'unit',
            title: 'Unit',
            href: 'unit',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            title: 'SSHCF',
            href: 'sshcf',
            isSub: true,
            acl: [
              {
                name: 'view_master_data_sshcf',
                permission: 'view'
              }
            ],
            children: [
              {
                title: 'Region',
                to: '/sshcf/regions'
              },
              {
                title: 'District',
                to: '/sshcf/districts'
              },
              {
                title: 'Plant',
                to: '/sshcf/plants'
              },
              {
                title: 'Vendor',
                to: '/sshcf/vendors'
              },
              {
                title: 'Company',
                to: '/sshcf/companies'
              },
              {
                title: 'Hospital',
                to: '/sshcf/hospitals'
              }
            ]
          },
          {
            id: 'faqCategory',
            title: 'FAQ Category',
            href: 'faqCategory',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'investment_type',
            title: 'Investment Type',
            href: 'investment_type',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-list-settings-line',
        title: 'Content Management',
        items: [
          {
            id: 'cms-menu',
            title: 'Guideline Text Menu',
            href: 'cmsMenu',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'docs',
            title: 'Guideline Document',
            href: 'docs',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'cms-text',
            title: 'Guideline Text',
            href: 'cmsText',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'faq',
            title: 'FAQ',
            href: 'faq',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-list-settings-line',
        title: 'Organization Management',
        items: [
          {
            id: 'dynamic-hierarchy',
            title: 'Dynamic Hierarchy',
            href: 'dynamic-hierarchy',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'dynamic-hierarchy',
            title: 'Dynamic Hierarchy Draft',
            href: 'draft-hierarchy',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'group',
            title: 'Group',
            href: 'group',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          },
          {
            id: 'dynamic-hierarchy',
            title: 'Dynamic Approval',
            href: 'dynamic-approval',
            acl: [
              {
                name: 'view_master_data',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-user-settings-line',
        title: 'User Management',
        items: [
          {
            id: 'user',
            title: 'User',
            href: 'user',
            acl: [
              {
                name: 'view_user',
                permission: 'view'
              }
            ]
          },
          {
            id: 'profile',
            title: 'Profile',
            href: 'profile',
            acl: [
              {
                name: 'view_profile',
                permission: 'view'
              }
            ]
          }
          // {
          //   id: 'permission',
          //   title: 'Permission',
          //   href: 'permission',
          //   acl: [
          //     {
          //       name: 'permission',
          //       permission: 'view'
          //     }
          //   ]
          // }
        ]
      },
      {
        icon: 'ri-settings-line',
        title: 'Configuration',
        items: [
          {
            id: 'config-adhoc',
            title: 'Config Ad hoc',
            href: 'config-adhoc',
            acl: [
              {
                name: 'adhoc_config',
                permission: 'update'
              }
            ]
          },
          {
            id: 'quarter',
            title: 'Config Quarter',
            href: 'config-quarter',
            acl: [
              {
                name: 'config',
                permission: 'update'
              }
            ]
          },
          {
            id: 'tolerance',
            title: 'Spending Tolerance',
            href: 'spending-tolerance',
            acl: [
              {
                name: 'config',
                permission: 'update'
              }
            ]
          },
          {
            id: 'password',
            title: 'Config Password',
            href: 'config-password',
            acl: [
              {
                name: 'compability_password',
                permission: 'update'
              }
            ]
          },
          {
            id: 'configUploadPO',
            title: 'Automatic Upload PO',
            href: 'automatic-upload-po',
            acl: [
              {
                name: 'po_automated_calendar',
                permission: 'update'
              }
            ]
          },
          {
            id: 'configUploadNonPO',
            title: 'Automatic Upload Non PO',
            href: 'automatic-upload-nonpo',
            acl: [
              {
                name: 'po_automated_calendar',
                permission: 'update'
              }
            ]
          },
          {
            id: 'configEmailSupport',
            title: 'Support Email Receiver',
            href: 'email-support',
            acl: [
              {
                name: 'config_email_help_center',
                permission: 'update'
              }
            ]
          },
          {
            id: 'configLockBudget',
            title: 'Lock Budget',
            href: 'lock-budget',
            acl: [
              {
                name: 'config_lock_budget',
                permission: 'view'
              }
            ]
          }
          // {
          //   id: 'tolerance',
          //   title: 'Spending Tolerance',
          //   href: 'spending-tolerance',
          //   acl: [
          //     {
          //       name: 'config',
          //       permission: 'update'
          //     }
          //   ]
          // }
        ]
      },
      {
        id: 'key-highlight',
        icon: 'ri-list-settings-line',
        title: 'Key Highlight',
        component: '/key-highlight',
        items: [],
        acl: [
          {
            name: 'key_highlight',
            permission: 'view'
          }
        ]
      },
      {
        id: 'financial-portal',
        icon: 'icon-icon-menu-4',
        title: 'Financial Portal',
        component: '/financial-portal/portal',
        items: [],
        acl: [
          {
            name: 'finance_portal_view',
            permission: 'view'
          }
        ]
      },
      {
        icon: 'icon-icon-menu-4',
        title: 'Financial Portal Config',
        items: [
          {
            id: 'finance-portal-config',
            title: 'Content Configuration',
            href: 'finance-portal-content-config',
            acl: [
              {
                name: 'finance_portal_config',
                permission: 'create'
              }
            ]
          },
          {
            id: 'finance-portal-guidebook',
            title: 'Guidebook Document',
            href: 'guidebook-docs',
            acl: [
              {
                name: 'finance_portal_config',
                permission: 'create'
              }
            ]
          }
        ]
      },
      {
        icon: 'ri-apps-2-line',
        title: 'Audit Trail',
        items: [
          {
            id: 'audit-trail',
            title: 'Audit Trail Master Data',
            href: 'audit-trail-master-data',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          },
          {
            id: 'ri-settings-line',
            title: 'Audit Trail User Management',
            href: 'audit-trail-user',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          },
          {
            id: 'audit-trail-lock-budget',
            title: 'Audit Trail Lock Budget',
            href: 'audit-trail-lock-budget',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          },
          {
            id: 'audit-trail-dynamic-hierarchy',
            title: 'Audit Trail Dynamic Hierarchy',
            href: 'audit-trail-dynamic-hierarchy',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          },
          {
            id: 'audit-trail-group',
            title: 'Audit Trail Group',
            href: 'audit-trail-group',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          },
          {
            id: 'audit-trail-login',
            title: 'Audit Trail Login',
            href: 'audit-trail-login',
            acl: [
              {
                name: 'view_audit_trail',
                permission: 'view'
              }
            ]
          }
        ]
      },
      {
        icon: 'svg-menu-8',
        title: 'MROI',
        items: [
          {
            id: 'shopper-activities',
            title: 'Shopper Activities',
            href: 'mroi-shopper',
            acl: [
              {
                name: 'view_mroi',
                permission: 'view'
              }
            ]
          }
        ]
      }
    ],
    width: 0,
    miniToolbar: false,
    notification: {},
    notifOpened: false,
    notifDrawer: false
  }),
  created() {
    this.interval = setInterval(() => this.getNotification(), 20000);
  },
  mounted() {
    this.profileItem();
    this.getNotification();
  },
  computed: {
    ...mapState('auth', {
      userMapping: 'mapping',
      sshcpMapping: 'sshcpMapping'
    }),
    regions() {
      return [...new Set(this.userMapping?.map(item => item.region))];
    },
    districts() {
      return [...new Set(this.userMapping?.map(item => item.district))];
    },
    sshcpRegions() {
      return [
        ...new Set(
          this.sshcpMapping
            ?.map(item => item.region_mapping_name)
            .filter(val => val !== null)
        )
      ];
    },
    sshcpDistricts() {
      return [
        ...new Set(
          this.sshcpMapping
            ?.map(item => item.district_mapping_name)
            .filter(val => val !== null)
        )
      ];
    },
    computedItems() {
      return this.profileItems.map(item => {
        return {
          id: item.id,
          text: item.desc,
          disabled: this.disabledItems === item.id ? true : false
        };
      });
    }
  },
  methods: {
    redirectApproval(val) {
      if (val.type_field === 'APPROVAL') {
        let yearApprove = val.message.split(']')[0].replace('[', '');
        this.$cookies.set('year', yearApprove);
        // let nameRoute = 'approval-dynamic';
        // if (this.$route.name !== nameRoute) {
        if (val.target_id) {
          /*redirect langsung ke bo untuk single approval*/
          console.log('target');
          this.$router.push({
            name: 'searchApproval',
            params: {
              yearIo: yearApprove,
              io: 'io',
              boIo: val.target_id
            }
          });
        } else {
          this.$router.push({
            name: 'approval-dynamic',
            params: {
              year: yearApprove
            }
          });
        }
        // } else {
        //   this.$cookies.set('year', yearApprove);
        //   this.$router.go();
        // }
      }
    },
    load(val) {
      this.progressDialogLoading = val;
    },
    getNotification() {
      let profile_id = localStorage.getItem('profile_id');
      let params = {
        profile_id: profile_id
      };
      if (this.$route.name !== 'login' && profile_id) {
        this.$store
          .dispatch('notification/getAll', params)
          .then(data => {
            if (data.code === 200) {
              this.notification = data.data;
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      }
    },
    readNotif() {
      this.notifDrawer = !this.notifDrawer;
      let params = {
        profile_id: Number(localStorage.getItem('profile_id'))
      };
      this.$store
        .dispatch('notification/read', params)
        .then(data => {
          if (data.code === 200) {
            this.notification.count = 0;
          } else {
            Swal.fire('Failed!', data.response.data.data.error, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.data.text_en, 'error');
        });
    },
    handleDrawer() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = !this.drawer;
      } else {
        this.miniToolbar = !this.miniToolbar;
      }
    },
    profileItem() {
      for (let i = 0; i < this.profileItems.length; i++) {
        if (this.profileItems[i].id == localStorage.getItem('profile_id')) {
          this.disabledItems = this.profileItems[i].id;
        }
      }
    },
    isWidth() {
      if (this.$vuetify.breakpoint.width < 1264) {
        return 'width-mdDown';
      } else {
        return 'width-mdUp';
      }
    },
    confirmLogout() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to logout?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: `Yes, logout!`,
        cancelButtonText: 'No, cancel!'
      }).then(result => {
        if (result.value) {
          this.logout();
        }
      });
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      localStorage.clear();
      this.$router.push({
        name: 'login'
      });
    },
    getIcon(pict) {
      return require('@/assets/images/navbar/' + pict + '.png');
    },
    submit() {
      this.progressDialogLoading = true;
      this.showDialog = false;
      if (this.profileId) {
        const params = {
          profile_id: this.profileId.id
        };
        this.$store
          .dispatch('auth/getRoleConfig', params)
          .then(data => {
            if (data.code === 200) {
              localStorage.setItem(
                'userRole',
                JSON.stringify(data.data.mapping)
              );
              localStorage.setItem('userProfile', JSON.stringify(data.data));
              localStorage.setItem(
                'profile_id',
                JSON.stringify(this.profileId.id)
              );
              this.desc = JSON.parse(localStorage.getItem('userProfile'));
              this.profileId = {};
              this.profileItem();
              const profile = data.data;
              if (profile && profile.desc === 'SSHCF') {
                this.$router.push({ name: 'sshcf_dashboard' });
                this.progressDialogLoading = false;
              } else if (profile && profile.desc.includes('SSHCP')) {
                this.$router.push({ name: 'sshcp_dashboard' });
                this.progressDialogLoading = false;
              } else {
                if (this.$router.currentRoute.name === 'dashboard') {
                  this.$router.go({ name: 'dashboard' });
                } else {
                  if (this.hasPermission('finance_portal_view', 'view')) {
                    this.$router.push({ name: 'financial-portal' });
                  } else {
                    this.$router.push({ name: 'dashboard' });
                  }
                  this.progressDialogLoading = false;
                }
              }
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      } else {
        this.showDialog = false;
      }
    },
    showChangePassword() {
      this.current_password = '';
      this.new_password = '';
      this.confirm_password = '';
      requestAnimationFrame(() => {
        this.$refs.changePassword.reset();
      });
      this.modalChangePassword = true;
    },
    changePassword() {
      this.showDialog = false;
      if (this.new_password === this.confirm_password) {
        this.progressDialogLoading = true;
        let params = {
          currentPassword: this.current_password,
          newPassword: this.new_password
        };
        this.$store
          .dispatch('auth/changePassword', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              clearTimeout(this.timeout);
              this.timeout = setTimeout(() => {
                this.logout();
              }, 500);
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      } else {
        Swal.fire(
          'Failed!',
          'Password Confirmation did not match. Please check and try again.',
          'error'
        );
      }
    }
  }
};
</script>
<style scoped>
.v-navigation-drawer__content {
  overflow: hidden !important;
}
.drawer-menu--scroll__ {
  height: calc(100vh - 200px) !important;
  overflow: auto;
}
.drawer-notif--scroll__ {
  height: calc(100vh - 128px);
  overflow: auto;
}
.notif_scroll {
  max-height: 250px;
  overflow: auto;
}
.v-toolbar__content,
.v-toolbar__extension {
  padding-left: 0px !important;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > div
  > .v-list-item {
  padding-left: 53px !important;
}
/* .v-navigation-drawer {
  width: 266px !important;
} */
.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 13px !important;
}
/* .v-toolbar {
  left: 266px !important;
}
.v-content {
  padding: 64px 0px 0px 266px !important;
} */
.theme--light.v-sheet {
  color: #404e67 !important;
}
/* .theme--light.v-icon {
  color: #47546c;
} */
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #404e67 !important;
}
.v-menu__content {
  border-radius: 10px !important;
}
.list-notif:hover {
  background: #eeeeee !important;
}
.custom-list-active {
  color: #28a0f6 !important;
}
.icon-color {
  filter: invert(20%) sepia(13%) saturate(318%) hue-rotate(200deg)
    brightness(73%) contrast(102%);
}
.icon-color-active {
  filter: invert(17%) sepia(61%) saturate(3712%) hue-rotate(181deg)
    brightness(100%) contrast(94%) !important;
}
.title-page {
  font-weight: bold;
  font-size: 24px !important;
  line-height: 15px !important;
  letter-spacing: -0.04em !important;
}
.text-subtitle-small {
  font-weight: 500 !important;
  font-size: 10px !important;
  line-height: 18px !important;
  color: #bdbdbd;
}
.v-icon.v-icon {
  font-size: 16.67px !important;
}
</style>
